import getGraphQlClient from '~graphql/getGraphQlClient';
import { unmarshalGraphqlResponse } from '~graphql/utils';
import { FETCH_MODULES } from '../queries/modules';

export const fetchModules = async (where = {}) => {
  const graphQlClient = await getGraphQlClient();

  const response = await graphQlClient.query({
    variables: { where },
    query: FETCH_MODULES,
  });
  return await unmarshalGraphqlResponse(response.data, 'modules').edges;
};
